import { message } from "antd";
import { checkAuthorization } from "../../helpers";
import { domainUrl } from "../../constants";

const getService= ()=>{
    const {userToken} = checkAuthorization()
    var myHeaders = new Headers()
    myHeaders.append('Authorization', userToken)
    return (
        fetch(domainUrl + "/servicesLookup", {
            method: "GET",
            headers: myHeaders
        })
        .then(response => response.json())
        .then(result => {
            if (result?.success) 
                return result?.data
            else
                throw result?.message
        })
        .catch(error => {
            message.error(error)
            return 0
        })
    )
}

const servicesLookup = {
    getService,
}

export {servicesLookup}
